const PERCENT = 100
const LOWEST = 0
const HIGHEST = 1

const clamp = (value: number): number => Math.min(HIGHEST, Math.max(LOWEST, Number.isFinite(value) ? value : LOWEST))

export const ThresholdScale = ({ value }: { value: number }) => (
  <span className="threshold-scale" aria-hidden="true">
    <span className="threshold-scale-track" />
    <span className="threshold-scale-mark" style={{ insetInlineStart: `${clamp(value) * PERCENT}%` }} />
  </span>
)
